import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide-v20';

import { FinalPriceRow } from '@sharedComponents/FinalPriceRow';
import { FooterRow } from '@sharedComponents/FooterRow';
import { InfoMark } from '@sharedComponents/InfoMark';

export const AlignedInfoMark = styled(InfoMark)`
  margin-left: 0.3125rem;
  display: inline-block;
`;

export const CartFinalPriceRow = styled(FinalPriceRow)`
  padding: 0.625rem 1.25rem 0.625rem 2rem;
  margin: 0 -1rem;

  @media (min-width: ${breakpoints.md}) {
    margin: 0;
  }
`;

export const StyledPageFooterRow = styled(FooterRow)`
  margin-top: 1.25rem;
  margin-bottom: 3.125rem;
`;
